const TestIDs = {
  ACCESSIBILITY: {
    BUTTON: 'accessibility-link',
  },
  ACTION_STRIP: {
    CONTAINER: 'action_strip',
  },
  AGREEMENT_DOC: {
    IFRAME: 'agreement_doc_iframe',
  },
  AGREEMENT_MODAL: {
    CONTAINER: 'agreement_modal_container',
    OVERLAY: 'agreement_modal_overlay',
    CLOSE_BUTTON: 'agreement_modal_close_btn',
  },
  ANALYZING: {
    LATER_ANIMATION: 'analyzing_later_animation',
  },
  AUTOCOMPLETE_ADDRESS: {
    LIST: 'autocomplete_address_list',
    LIST_ITEM: 'autocomplete_address_list_item',
  },
  AUTO_SCROLLER: {
    CONTAINER: 'autoscroller_container',
    CTA: 'autoscroller_cta',
  },
  CONTACT_INFO: {
    ADDRESS_LINE_1: 'contact_info_address_line_1',
    ADDRESS_LINE_2: 'contact_info_address_line_2',
    CITY: 'contact_info_city',
    STATE: 'contact_info_state',
    ZIP_CODE: 'contact_info_zipcode',
    PHONE_NUMBER: 'contact_info_phone_number',
    SUBMIT_CTA: 'contact_info_submit_cta',
    SUGGESTION_CONTAINER: 'contact_info_suggestion_container',
    SUGGESTION_HEADER: 'contact_info_suggestion_header',
    SUGGESTION_BODY: 'contact_info_suggestion_body',
    SUGGESTION_SEPARATOR: 'contact_info_suggestion_separator',
  },
  DIRECT_TO_MOBILE: {
    APP_STORE_BUTTON: 'direct_to_mobile_app_store_button',
    GOOGLE_PLAY_BUTTON: 'direct_to_mobile_google_play_button',
    DOWNLOAD_ACORNS_TITLE: 'download_acorns_title',
    DOWNLOAD_ACORNS_MESSAGE: 'download_acorns_message',
  },
  ESG_EDUCATION: {
    LEFT_ARROW: 'esg_education_left_arrow',
    RIGHT_ARROW: 'esg_education_right_arrow',
    LETS_GO_BUTTON: 'esg_education_lets_go_button',
    DONE_BUTTON: 'esg_education_done_button',
  },
  INSTITUTIONS: {
    INSTITUTION_CONTAINER: 'institutions_institution_container',
    NO_MATCHES_LINK: 'institutions_no_matches_link',
    RESULTS_LIST: 'institutions_results_list',
  },
  INVEST_INTERSTITIAL: {
    NEXT_BUTTON: 'invest_interstitial_next_cta',
    IMAGE: 'invest_interstitial_image',
  },
  INVESTOR_QUESTIONS: {
    SUBMIT_CTA: 'investor_questions_submit_cta',
  },
  LATER_IRA_RECOMMENDATION: {
    TITLE: 'later_ira_recommendation_title',
    TEXT: 'later_ira_recommendation_text',
    SUBTEXT: 'later_ira_recommendation_subtext',
    SUBMIT_CTA: 'later_ira_recommendation_submit_cta',
  },
  LATER_SUITABILITY_QUESTIONS: {
    NEXT_CTA: 'later_suitability_questions_next_cta',
  },
  MANUAL_FUNDING_SOURCE: {
    ROUTING_NUMBER: 'manual_funding_source_routing_number',
    ACCOUNT_NUMBER: 'manual_funding_source_account_number',
    CONFIRM_ACCOUNT_NUMBER: 'manual_funding_source_confirm_account_number',
    SKIP_CTA: 'manual_funding_sournce_skip_cta',
    SUBMIT_BUTTON: 'manual_funding_source_submit_button',
  },
  MOC_INTERSTITIAL: {
    TITLE: 'moc_interstitial_title',
    IMAGE: 'moc_interstitial_image',
    NEXT_BUTTON: 'moc_interstitial_cta',
    MOBILE_NAV: 'moc_interstitial_mobile_nav',
    MORE_INFO_BUTTON: 'moc_interstitial_more_info',
    SKIP_BUTTON: 'moc_interstitial_skip',
  },
  MOC_PROGRESS_ONE: {
    TITLE: 'moc_progress_one_title',
    IMAGE: 'moc_progress_one_image',
    NEXT_BUTTON: 'moc_progress_one_cta',
  },
  MOC_PROGRESS_TWO: {
    TITLE: 'moc_progress_two_title',
    IMAGE: 'moc_progress_two_image',
    NEXT_BUTTON: 'moc_progress_two_cta',
  },
  MOC_PROGRESS_THREE: {
    TITLE: 'moc_progress_three_title',
    IMAGE: 'moc_progress_three_image',
    NEXT_BUTTON: 'moc_progress_three_cta',
  },
  MOC_REFERRAL_REMINDER: {
    TITLE: 'moc_referral_reminder_title',
    TEXT: 'moc_referral_reminder_text',
    DESCRIPTION: 'moc_referral_reminder_desc',
    NEXT_BUTTON: 'moc_referral_reminder_cta',
  },
  FUNDING_PAGE: {
    CORE_IMAGE: 'funding_image_core',
    LATER_IMAGE: 'funding_image_later',
  },
  FUNDING_CHECKING: {
    TITLE: 'funding_checking_title',
    TEXT: 'funding_checking_text',
    DESCRIPTION: 'funding_checking_description',
    DIRECT_DEPOSIT_BUTTON: 'funding_checking_direct_deposit_button',
    BANK_LINKING_BUTTON: 'funding_checking_bank_linking_button',
  },
  BANK_LINK_SUCCESS: {
    CORE_IMAGE: 'bank_link_success_image_core',
    LATER_IMAGE: 'bank_link_success_image_later',
    SUBMIT_BUTTON: 'bank_link_success_submit_button',
  },
  NAV: {
    BACK_BUTTON: 'nav_back_button',
    LINK: 'nav_link',
    PROGRESS_BAR: 'progress_bar',
    HEADER: 'nav_header',
  },
  TOAST: {
    CLOSE_BUTTON: 'close_button',
  },
  OCCUPATION: {
    TITLE: 'occupation_title',
    NEXT_BUTTON: 'occupation_cta',
  },
  PARTNER_BANNER: {
    LOGO_TXT: 'partner_banner_text',
    LOGO_IMG: 'partner_banner_logo',
  },
  PERSONAL_INFO: {
    SUBMIT_CTA: 'personal_info_submit_cta',
    US_CITIZEN_CHECKBOX: 'checkbox_input',
  },
  PLAY_BUTTON: 'play_button',
  PORTFOLIO_OVERVIEW: {
    TITLE: 'hero_title',
    BODY: 'hero_body',
    DOLLAR_CONTAINER: 'portfolio_overview_dollar_container',
    BONDS_PERCENT: 'portfolio_overview_bonds_percent',
    STOCKS_PERCENT: 'portfolio_overview_stocks_percent',
    REAL_STATE_PERCENT: 'portfolio_overview_real_state_percent',
  },
  PORTFOLIO_RECOMMENDATION: {
    OPEN_ACCOUNTS_CTA: 'open_accounts_cta',
  },
  PRICING_INTERSTITIAL: {
    COMPARE_TIERS_BUTTON: 'compare_tiers_button',
    TIER_NAME: 'pricing_interstitial_tier_name',
    TIER_PRICE: 'pricing_interstitial_tier_price',
    BENEFITS_CONTAINER: 'pricing_interstitial_tier_benefits',
    BUNDLE_CONTAINER: 'pricing_interstitial_tier_bundle_container',
    CTA: 'pricing_interstitial_cta',
    IMAGE: 'pricing_interstitial_image',
    MOC_TITLE: 'moc_tier_title',
    MOC_NEXT_BUTTON: 'moc_cta',
    MOC_MORE_INFO_BUTTON: 'moc_more_info',
    MOC_TIER_PRICE: 'moc_tier_price',
    MOC_WAIVED_TIER_PRICE: 'moc_waived_tier_price',
    MOC_TIER_DISCLOSURE: 'moc_tier_disclosure',
    MOC_TIER_DIRECT_DEPOSIT_PRIVACY_POLICY: 'moc_tier_direct_deposit_privacy_policy',
    MOC_HEADER_BODY: 'moc_tier_header_body',
    MOC_BENEFIT_TITLE: 'moc_tier_benefit_title',
    MOC_TIER_SWITCH: 'moc_tier_switch',
  },
  PREVIEW_PORTFOLIO: {
    TITLE: 'hero_title',
    PROJECTION_TITLE: 'preview_portfolio_projection_title',
    DESCRIPTION_TITLE: 'preview_portfolio_description_title',
    BODY: 'hero_body',
    BUTTON: 'preview_portfolio_button',
    BONDS_PERCENT: 'preview_portfolio_bonds_percent',
    CRYPTO_PERCENT: 'preview_portfolio_crypto_percent',
    STOCKS_PERCENT: 'preview_portfolio_stocks_percent',
    PORTFOLIO_ETF: 'portfolio_etf',
    ABOUT_ESG_LINK: 'about_esg_link',
    PORTFOLIO_RECOMMENDED_RISK: 'portfolio_recommended_risk',
  },
  REACT_PLAYER_VIDEO: 'react_player_video',
  REFERRAL_BANNER: {
    BANNER_TXT: 'referral_banner_text',
  },
  REFERRAL_DISCLOSURE: {
    HERO_BANNER_TEXT: 'referral_disclosure_hero_banner_text',
    DISCLAIMER_TEXT: 'referral_disclosure_disclaimer_text',
    DOCUMENT_TEXT: 'referral_disclosure_document_text',
    SIGN_BUTTON: 'referral_disclosure_sign_button',
  },
  REFERRAL_REWARD: {
    TITLE: 'referral_reward_title',
    BODY: 'referral_reward_body',
    NEXT_BUTTON: 'referral_reward_next_button',
  },
  ROUNDUPS_INTERSTITIAL: {
    IMAGE: 'round_ups_interstitial_image',
    NEXT_BUTTON: 'round_ups_interstitial_next_cta',
    MORE_INFO: 'round_ups_interstitial_more_info',
  },
  ROUNDUPS_SETUP: {
    AUTOMATIC_OPTION: 'roundups_setup_automatic_option',
    MANUAL_OPTION: 'roundups_setup_manual_option',
    NEXT_BUTTON: 'round_ups_setup_next_cta',
  },
  ROUNDUPS_FUNDING: {
    CHECKING_OPTION: 'plaid_checking',
    SAVINGS_OPTION: 'plaid_saving',
    NEXT_BUTTON: 'round_ups_funding_next_cta',
  },
  ROUNDUPS_PAST: {
    MOBILE_TOTAL_COST: 'round_ups_past_mobile_total_cost',
    NEXT_BUTTON: 'round_ups_past_next_cta',
    SKIP_BUTTON: 'nav_link',
  },
  SECOND_CHANCE: {
    LINK_BANK_BUTTON: 'link_bank_button',
  },
  SELECT_PORTFOLIO_THEME: {
    CORE_BUTTON: 'portfolio_theme_select_core_button',
    SUSTAINABLE_BUTTON: 'portfolio_theme_select_sustainable_button',
    LEARN: 'portfolio_theme_select_learn_button',
    NEXT: 'portfolio_theme_select_next_button',
  },
  SELECT_TIER: {
    HEADER: 'select_tier_header',
    BODY: 'select_tier_body',
    CARD: {
      TITLE: 'select_tier_card_title',
      PRICE: 'select_tier_card_price',
      CTA: 'select_tier_card_cta',
    },
  },
  SIGN_YOUR_CARD: {
    SIGN_WITH_PHONE_BUTTON: 'sign_with_phone_button',
    NEXT_BUTTON: 'sign_your_card_next',
    SIGN_WITH_PHONE_MODAL: 'sign_with_phone_modal',
    SEND_LINK_BUTTON: 'send_link_button',
    MODAL_CLOSE_BUTTON: 'sign_with_phone_modal_close_button',
  },
  SIGNUP: {
    GET_STARTED_BUTTON: 'signup_get_started_button',
    CREATE_ACCOUNT_BUTTON: 'signup_create_button',
    AGREEMENT_MODAL: 'signup_agreement_modal',
    ONE_SPECIAL_CHAR_ERROR: 'validation-item-error-one_special_char',
    RESUME_MODAL: 'signup_resume_modal',
  },
  SPEND_ORDER_CONFIRMATION: {
    SPEND_CARD_IMAGE: 'spend_order_confirmation_card_image',
    SPEND_CARD_USER_SIGNATURE: 'spend_order_confirmation_user_signature',
    SPEND_CARD_USER_NAME: 'spend_order_confirmation_user_name',
    EDIT_SIGNATURE_BUTTON: 'edit_signature_button',
    EDIT_ADDRESS_BUTTON: 'edit_address_button',
    NEXT_BUTTON: 'spend_order_confirmation_next_button',
  },
  SPEND_PREFUND: {
    HEADER: 'spend_prefund_header',
    TEXT: 'spend_prefund_text',
    PREFUND_AMOUNT: 'spend_prefund_amount_button',
    NEXT_BUTTON: 'spend_prefund_next_button',
  },
  SPINNER: 'spinner',
  SSN: {
    SUBMIT_CTA: 'ssn_submit_cta',
  },
  START_INVESTING: {
    LATER_RECURRING_TITLE: 'start_investing_later_recurring_title',
    LATER_ONE_TIME_TITLE: 'start_investing_later_one_time_title',
    RECURRING_SUBTITLE: 'start_investing_subtitle',
    LINK_BANK_ACCOUNT_BUTTON: 'link_bank_account_button',
    SUBMIT_CTA: 'start_investing_submit_cta',
    SKIP_CTA: 'start_investing_skip_cta',
    MAKE_ONE_TIME_BUTTON: 'make_one_time_button',
  },
  SUCCESS: {
    SUCCESS_MESSAGE: 'success_message',
    CHANGE_EMAIL_LINK: 'change_email_link',
    PARTNER_REDIRECT_LINK: 'success_partner_redirect_link',
    LOGIN_CTA: 'login_cta',
    APP_STORE: 'app_store_cta',
    GOOGLE_PLAY: 'google_play_cta',
    LATER_TITLE: 'success_later_title',
    LATER_TEXT: 'success_later_text',
    OPEN_ACORNS_CTA: 'success_open_acorns_cta',
    EARLY_TIER: {
      IMAGE: 'early_tier_success_image',
      NEXT_CTA: 'early_tier_next_cta',
      UNVERIFIED_CTA: 'early_tier_unverified_cta',
    },
    LATER_ONBOARDING: {
      TITLE: 'success_later_onboarding_title',
      SUBMIT_CTA: 'success_later_onboarding_submit_cta',
      IMAGE: 'success_later_onboarding_image',
    },
    MOC: {
      TITLE: 'moc_success_title',
      TITLE_ALT: 'moc_success_title_alternative',
      BODY: 'moc_success_body',
      BODY_ALT: 'moc_success_body_alternative',
    },
  },
  SUITABILITY_INTERSTITIAL: {
    IMAGE: 'suitability_interstitial_image',
    HEADER: 'suitability_interstitial_header',
    TEXT: 'suitability_interstitial_text',
    SUBMIT_CTA: 'suitability_interstitial_submit_cta',
  },
  SUITABILITY_QUESTIONS: {
    SUBMIT_CTA: 'suitability_questions_submit_cta',
  },
  UTILS: {
    PROMPT_MODAL: 'utils_prompt_modal',
  },
  WELCOME: {
    LATER: {
      HEADER: 'welcome_later_header',
      TEXT: 'welcome_later_text',
      SUBMIT_CTA: 'welcome_later_submit_cta',
      VIDEO_HEADER: 'welcome_later_video_header',
    },
    LATER_ONBOARDING: {
      HERO_IMAGE: 'later_onboarding_hero_image',
      TITLE: 'later_onboarding_title',
      SUBMIT_CTA: 'later_onboarding_submit_cta',
      SUBSCRIPTION_INCLUDES_LATER_TEXT: 'later_onboarding_subscription_includes_later_text',
      SUBSCRIPTION_SUBTEXT: 'later_onboarding_subscription_subtext',
      HEADING: 'later-onboarding-heading',
      SUBHEADING: 'later-onboarding-subheading',
      INTRO_CONTENT: 'later-onboarding-intro-content',
      DETAILS_CONTENT: 'later-onboarding-details-content',
      ONBOARDING_CTA: 'later-onboarding-cta',
      ONBOARDING_MOBILE_CTA: 'later-onboarding-mobile-cta',
    },
    SPEND: {
      HEADER: 'welcome_spend_header',
      TEXT: 'welcome_spend_text',
      GET_STARTED_CTA_TOP: 'welcome_spend_get_started_cta_top',
      GET_STARTED_CTA_BOTTOM: 'welcome_spend_get_started_cta_bottom',
      IMAGE_HEADER: 'welcome_spend_card_image',
      ACORNS_INVEST_ACCORDION: 'welcome_spend_invest_accordion',
      ACORNS_LATER_ACCORDION: 'welcome_spend_later_accordion',
      LEARN_MORE_CTA: 'welcome_spend_learn_more_video_cta',
    },
  },
  MAINTENANCE: {
    CARD: 'maintenance_card',
  },
  ERROR_STATE: {
    CONTAINER: 'error_state_container',
  },
}

export { TestIDs }
